<template>
  <div class="row align-items-center justify-content-center bg-light">
    <ul class="pagination text-center">
      <!-- 맨 앞으로 -->
      <li :class="{ 'page-item': true, disabled: page === 1 }" @click="goToFirst">
        <a class="page-link" aria-label="First">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <!-- 이전 -->
      <li :class="{ 'page-item': true, disabled: page === 1 }" @click="previousPage">
        <a class="page-link" aria-label="Previous">
          <span aria-hidden="true">&lsaquo;</span>
        </a>
      </li>
      <!-- 페이지 번호들 -->
      <li
        v-for="pageIndex in displayedPages"
        :key="pageIndex"
        :class="{ 'page-item': true, active: pageIndex === page }"
      >
        <a class="page-link" @click="page = pageIndex">{{ pageIndex }}</a>
      </li>
      <!-- 다음 -->
      <li :class="{ 'page-item': true, disabled: page === pages }" @click="nextPage">
        <a class="page-link" aria-label="Next">
          <span aria-hidden="true">&rsaquo;</span>
        </a>
      </li>
      <!-- 맨 끝으로 -->
      <li :class="{ 'page-item': true, disabled: page === pages }" @click="goToLast">
        <a class="page-link" aria-label="Last">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    pages: {
      type: Number,
      required: true
    },
    maxVisible: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      page: 1,
      timer: null
    };
  },
  methods: {
    goToFirst() {
      if (this.page !== 1) {
        this.page = 1;
      }
    },
    goToLast() {
      if (this.page !== this.pages) {
        this.page = this.pages;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page -= 1;
      }
    },
    nextPage() {
      if (this.page < this.pages) {
        this.page += 1;
      }
    }
  },
  watch: {
    page(newPage, oldPage) {
      if (newPage === oldPage) return;

      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.$emit("pagechange", this.page), 0);
    },
    pages(newPages) {
      // 전체 페이지 수가 변경되면 현재 페이지가 범위를 벗어나는지 확인
      if (newPages > 0 && this.page > newPages) {
        this.page = newPages;
      } else if (newPages === 0) {
        this.page = 1;
      }
    }
  },
  computed: {
    displayedPages() {
      var result = [];
      var totalPages = this.pages;
      var currentPage = this.page;
      var maxVisible = this.maxVisible;

      if (totalPages <= maxVisible) {
        // 전체 페이지가 maxVisible 이하면 모두 표시
        for (var i = 1; i <= totalPages; i++) {
          result.push(i);
        }
      } else {
        // 현재 페이지를 중심으로 표시
        var half = Math.floor(maxVisible / 2);
        var start = currentPage - half;
        var end = currentPage + half;

        // 시작이 1보다 작으면 조정
        if (start < 1) {
          start = 1;
          end = maxVisible;
        }

        // 끝이 전체 페이지보다 크면 조정
        if (end > totalPages) {
          end = totalPages;
          start = totalPages - maxVisible + 1;
        }

        for (var j = start; j <= end; j++) {
          result.push(j);
        }
      }

      return result;
    }
  }
};
</script>

<style scoped>
.pagination {
  margin: 0;
}

.page-item {
  cursor: pointer;
}

.page-item.disabled {
  cursor: not-allowed;
}

.page-item.disabled .page-link {
  pointer-events: none;
}
</style>
